import { useEffect, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import MenuItem from "./MenuItem"
import IconButton from "@mui/material/IconButton"
import LogoutIcon from "@mui/icons-material/Logout"
import { deleteToken, fetchToken } from "../../Auth"
import axios from "axios"
import { adminURL } from "../../global"
import "../../assets/css/adminSidebar.css"
import logo from "../../assets/img/logo-2.webp"

const Sidebar = () => {
  const [superAdmin, setSuperAdmin] = useState(false)
  const [user, setUser] = useState({})
  const [active, setActive] = useState("home")
  const [open, setOpen] = useState(false)

  const icons = {
    users: "fa-solid fa-user",
    tech: "fa-solid fa-microchip",
    "5": "fa-solid fa-pencil",
    "1": "fa-regular fa-file-lines",
    "3": "fa-solid fa-microphone-lines",
    "4": "fa-solid fa-headset",
    "2": "fa-solid fa-newspaper",
    logs: "fa-solid fa-clipboard",
    "6": "fa-solid fa-link",
    "7": "fa-solid fa-user-tie",
    home: "fa-solid fa-house",
  }

  const navigate = useNavigate()
  const location = useLocation()

  const signOut = () => {
    deleteToken()
    navigate(`/niyantran-panel/${adminURL}/login`)
  }

  const isSuperAdmin = async () => {
    try {
      const response = await axios.get(`/is_super_admin`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${fetchToken("nuprice_access_token")}`,
        },
      })
      if (response.status == 200 && response.data !== undefined) {
        setSuperAdmin(response.data)
      }
    } catch (err) {
      console.error("Error", err)
      if (err.response.status === 401) {
        navigate(`/niyantran-panel/${adminURL}/login`)
      }
    }
  }

  useEffect(() => {
    isSuperAdmin()
    if (window.location.href.includes("case")) {
      setActive("2")
    } else if (window.location.href.includes("website")) {
      setActive("6")
    } else if (window.location.href.includes("hr-content")) {
      setActive("7")
    } else if (window.location.href.includes("road")) {
      setActive("3")
    } else if (window.location.href.includes("expert")) {
      setActive("4")
    } else if (window.location.href.includes("forms")) {
      setActive("5")
    } else if (window.location.href.includes("user")) {
      setActive("users")
    } else if (window.location.href.includes("tech")) {
      setActive("tech")
    } else if (window.location.href.includes("admin-logs")) {
      setActive("logs")
    } else if (window.location.href.includes("blogs")) {
      setActive("1")
    } else if (window.location.href.includes("home")) {
      setActive("home")
    }
  }, [])

  const [dashboards, setDashboards] = useState([])

  const fetchDashboards = async () => {
    try {
      const response = await axios.get(`/user_dashboards`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${fetchToken("nuprice_access_token")}`,
        },
      })

      if (response.status === 200 && response.data) {
        const data = response.data.dashboards
        setDashboards(data)
      }
    } catch (err) {
      console.error("Error fetching dashboards:", err)
      if (err.response?.status === 401) {
        navigate(`/niyantran-panel/${adminURL}/login`)
      }
    }
  }

  useEffect(() => {
    fetchDashboards()
  }, [])

  return (
    <>
      <div className={open ? "sidebar open" : "sidebar"}>
        <div className="logo-details d-flex justify-content-center align-items-center">
          <img style={{ height: "2em" }} src={logo || "/placeholder.svg"} alt="Logo" />
        </div>

        {/* Main content area with fixed height to leave space for profile */}
        <div className="sidebar-content">
          {/* First item always visible */}
          {dashboards.length > 0 && (
            <div className="fixed-nav-item">
              <MenuItem
                key={dashboards[0][1]}
                active={dashboards[0][0] === active}
                link={dashboards[0][2]}
                menuTitle={dashboards[0][1]}
                icon={dashboards[0][0] in icons ? icons[dashboards[0][0]] : icons["default"]}
              />
            </div>
          )}

          {/* Scrollable items */}
          <div className="scrollable-nav-items">
            {dashboards.slice(1).map((d) => (
              <MenuItem
                key={d[1]}
                active={d[0] === active}
                link={d[2]}
                menuTitle={d[1]}
                icon={d[0] in icons ? icons[d[0]] : icons["default"]}
              />
            ))}
          </div>
        </div>

        {/* Profile section - always visible at bottom */}
        <div className="profile">
          <div className="profile-details">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Default_pfp.svg/1024px-Default_pfp.svg.png"
              alt="profile"
            />
            <div className="name_job">
              <div className="name">
                {user.first_name} {user.last_name}
              </div>
              <div className="email text-white">{user.username}</div>
            </div>
          </div>
          <IconButton onClick={() => signOut()} id="log_out" aria-label="delete" size="large">
            <LogoutIcon className="text-white" />
          </IconButton>
        </div>
      </div>
    </>
  )
}

export default Sidebar
